import React from 'react'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Icon, Button, Grid } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import { useAppName } from 'commons/usePartner'

const useStyles = makeStyles((theme) => ({
  classClose: {
    textAlign: 'center',
    fontSize: '22px',
    cursor: 'pointer',
  },
  iconSize: {
    fontSize: '22px',
    color: '#000000',
    fontWeight: 'bold',
  },
}))

export default (props) => {
  const { open, setOpen } = props
  const classes = useStyles()
  const appName = useAppName()
  return (
    <ResponsiveDialog
      isFullScreen={false}
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <FormattedMessage id="beacon.overview.dialog.thankYou.title" />
          </Grid>
          <Grid item xs={1} className={classes.classClose}>
            <Icon
              className={classes.iconSize}
              color="action"
              onClick={() => setOpen(false)}
            >
              close
            </Icon>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <FormattedMessage
            id="beacon.overview.dialog.thankYou.body"
            values={{ appName }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          variant="contained"
          color="secondary"
          className="uppercase"
        >
          <FormattedMessage id="action.ok" />
        </Button>
      </DialogActions>
    </ResponsiveDialog>
  )
}
